import axios from 'axios'

const client = axios.create({
  baseURL: '/api/v1',
  withCredentials: true, // invia cookie JWT httponly
  headers: { 'Content-Type': 'application/json' },
})

// Identifica il client (mobile vs web): l'app nativa setta `window.__EDR_CLIENT__ = 'mobile'`
// nello script iniettato nella WebView. Il backend usa questo header per decidere se
// consentire il login del terzista (policy: terzista solo da app mobile).
client.interceptors.request.use((config) => {
  const w = window as unknown as { __EDR_CLIENT__?: string }
  if (w.__EDR_CLIENT__) {
    config.headers.set('X-EDR-Client', w.__EDR_CLIENT__)
  }
  return config
})

// Flag per evitare che N request fallite in parallelo scatenino N redirect
let _handlingUnauth = false

// Interceptor: se 401 prova refresh, poi ritenta
client.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config
    if (error.response?.status === 401 && !original._retry) {
      original._retry = true
      try {
        await axios.post('/api/v1/auth/refresh', {}, { withCredentials: true })
        return client(original)
      } catch {
        // Refresh fallito: usa la navigazione SPA invece di window.location.href
        // per evitare hard reload (e conseguente sfarfallio) quando ci sono
        // più request in volo che falliscono tutte con 401.
        if (!_handlingUnauth) {
          _handlingUnauth = true
          // import dinamico evita dipendenza circolare
          import('@/store/authStore').then(({ useAuthStore }) => {
            useAuthStore.getState().clearAuth()
            // RequireAuth rileva isAuthenticated=false e fa <Navigate to="/login">
          }).finally(() => {
            setTimeout(() => { _handlingUnauth = false }, 3000)
          })
        }
      }
    }
    return Promise.reject(error)
  }
)

export default client
